import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrailingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.866 5.44a.6.6 0 0 0-1.2 0V7.5a2.2 2.2 0 0 0 2.2 2.2h6.497l-.518.518a.55.55 0 0 0 .778.778l1.562-1.563a.55.55 0 0 0 0-.778L11.618 7.09a.55.55 0 1 0-.778.778l.635.634H4.867a1 1 0 0 1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTrailingIcon;
